import { createTheme, ThemeProvider } from "@mui/material/styles";

type CustomTypographyVariants =
  | "heading_XL"
  | "heading_L"
  | "heading_M"
  | "heading_S"
  | "heading_XS"
  | "body_L"
  | "body_M"
  | "body_S"
  | "label_L"
  | "label_M"
  | "label_S";

declare module "@mui/material/styles" {
  interface TypographyVariants extends Record<CustomTypographyVariants, React.CSSProperties> {}
  interface TypographyVariantsOptions
    extends Partial<Record<CustomTypographyVariants, React.CSSProperties>> {}
}

declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides extends Record<CustomTypographyVariants, true> {}
}

const theme = createTheme({
  palette: {
    text: {
      primary: "#333333",
      secondary: "#666666",
      disabled: "#3333333F",
    },
    primary: {
      main: "#0064C8",
    },
    secondary: {
      main: "#333333",
    },
    background: {
      default: "#F8F8F7",
    },
  },
  typography: {
    fontSize: 16,
    fontFamily: ['"Noto Sans JP"', "sans-serif", '"M PLUS 1"', '"Century Gothic"'].join(","),
    // fontFamily: ["WDXL Lubrifont JP N", "sans-serif"].join(","),
    heading_XL: {
      fontSize: "1.75rem",
      lineHeight: 1.4,
      fontWeight: 600,
    },
    heading_L: {
      fontSize: "1.5rem",
      lineHeight: 1.4,
      fontWeight: 600,
    },
    heading_M: {
      fontSize: "1.25rem",
      lineHeight: 1.4,
      fontWeight: 600,
    },
    heading_S: {
      fontSize: "1.125rem",
      lineHeight: 1.4,
      fontWeight: 600,
    },
    heading_XS: {
      fontSize: "1rem",
      lineHeight: 1.4,
      fontWeight: 600,
    },
    body_L: {
      fontSize: "1.125rem",
      lineHeight: 1.5,
    },
    body_M: {
      fontSize: "1rem",
      lineHeight: 1.5,
      // color: "#3333333F",
    },
    body_S: {
      fontSize: "0.875rem",
      lineHeight: 1.5,
    },
    label_L: {
      fontSize: "1rem",
    },
    label_M: {
      fontSize: "0.875rem",
    },
    label_S: {
      fontSize: "0.75rem",
    },
    button: {
      fontSize: "0.875rem",
      fontWeight: 700,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },

    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: "0.875rem",
          // textAlign: "center",
        },
      },
    },
    MuiInputLabel: {
      defaultProps: {
        shrink: true,
      },
      styleOverrides: {
        root: {
          fontSize: "0.875rem",
          color: "#3333333F",
        },
        shrink: {
          fontSize: "0.75rem",
          color: "#333",
          transform: "translate(calc(0.75rem), -8px) scale(1)",
        },
      },
    },
    MuiOutlinedInput: {
      defaultProps: {
        notched: true,
      },
      styleOverrides: {
        notchedOutline: {
          borderColor: "#CCCCCC",
          "& legend": {
            width: "auto",
          },
          "& legend span": {
            display: "inline-block",
            width: "auto",
            padding: 2,
          },
        },
      },
    },

    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: "0.875rem",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontSize: "0.875rem",
          padding: "0 4px",
          height: "24px",
        },
      },
    },
  },
});

export default theme;
